import { InjectionToken } from '@angular/core';

import { SelectResolvedTemplate } from '../../types';

export interface GroupsFeatureDir {
  headers: Record<number, string>;
  listItem: SelectResolvedTemplate<any>;
}

export const GROUPS_FEATURE = new InjectionToken<GroupsFeatureDir>('groups feature');
